"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoursLegendHeader = exports.PMText = exports.AMText = exports.SunIcon = exports.SecondMoonIcon = exports.FirstMoonIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const icons_1 = require("../icons");
const Text_1 = require("../Text");
exports.FirstMoonIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    position: absolute;
    left: 0;
`;
exports.SecondMoonIcon = (0, styled_components_1.default)(Icon_1.Icon) `
    position: absolute;
    right: 0;
    z-index: -1;
`;
exports.SunIcon = (0, styled_components_1.default)(Icon_1.Icon) ``;
const StyledText = (0, styled_components_1.default)(Text_1.Text) `
    width: 100%;
`;
exports.AMText = (0, styled_components_1.default)(StyledText) `
    padding-left: ${helpers_1.SPACING_M};
`;
exports.PMText = (0, styled_components_1.default)(StyledText) `
    padding-right: ${helpers_1.SPACING_M};
`;
const Root = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 16px;

    position: relative;
    overflow: hidden;
`;
exports.HoursLegendHeader = (0, helpers_1.createUIElement)('HoursLegendHeader', (_a, ref) => {
    var { className, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(Root, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: `vm-HoursLegendHeader ${className}`, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(exports.FirstMoonIcon, { src: react_1.default.createElement(icons_1.NightIcon, null) }),
        react_1.default.createElement(exports.SecondMoonIcon, { src: react_1.default.createElement(icons_1.NightIcon, null) }),
        react_1.default.createElement(exports.AMText, { align: Text_1.TEXT_ALIGN.center, truncate: true }, "AM"),
        react_1.default.createElement(exports.SunIcon, { src: react_1.default.createElement(icons_1.DayIcon, null) }),
        react_1.default.createElement(exports.PMText, { align: Text_1.TEXT_ALIGN.center, truncate: true }, "PM")));
});
//# sourceMappingURL=HoursLegendHeader.js.map